export default __webpack_public_path__ + "static/media/Minotaur.768311d1.png";